/**
 * NotFoundPage: an address with nothing at it. Says so calmly, says
 * nothing of the person's is affected, and offers the two doors that
 * always exist.
 */
import type { ReactNode } from 'react';
import { Link, useParams } from 'react-router-dom';
import { defaultTenant } from '@/lib/auth';

export function NotFoundPage(): ReactNode {
  const { tenantSlug } = useParams<{ tenantSlug: string }>();
  const slug = tenantSlug ?? defaultTenant;
  return (
    <div data-testid="not-found-page" className="flex items-center justify-center px-6 py-16">
      <div className="max-w-md text-center">
        <h1 className="font-display text-2xl font-semibold text-sage-800 mb-2">There's nothing here</h1>
        <p className="text-sm text-ink-soft mb-6">
          Your work is safe. Head back to Home, or check the link.
        </p>
        <div className="flex items-center justify-center gap-3">
          <Link
            to={`/t/${slug}/hub`}
            className="px-4 py-2 rounded-pill bg-sage-800 text-cream text-sm font-semibold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage-400"
          >
            Back to Home
          </Link>
          <Link
            to={`/t/${slug}/clients`}
            className="px-4 py-2 rounded-pill text-sage-800 text-sm font-semibold underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage-400"
          >
            Clients
          </Link>
        </div>
      </div>
    </div>
  );
}
